/* eslint no-redeclare: 0 */
/* eslint camelcase: 0 */

/**
 * @public
 * Supported push types
 */
export const PushType = {
	appPush: 'appPush',
	timedPush: 'timedPush',
	instantPush: 'instantPush'
} as const;
export type PushType = (typeof PushType)[keyof typeof PushType];

/**
 * @public
 * Theme ids of supported themes
 */
export const ThemeId = {
	none: 'none',
	sap_horizon: 'sap_horizon',
	sap_horizon_dark: 'sap_horizon_dark',
	sap_horizon_hcb: 'sap_horizon_hcb',
	sap_horizon_hcw: 'sap_horizon_hcw',
	sap_fiori_3: 'sap_fiori_3',
	sap_fiori_3_dark: 'sap_fiori_3_dark',
	sap_fiori_3_hcb: 'sap_fiori_3_hcb',
	sap_fiori_3_hcw: 'sap_fiori_3_hcw',
	sap_belize: 'sap_belize',
	sap_belize_plus: 'sap_belize_plus',
	sap_belize_hcb: 'sap_belize_hcb',
	sap_belize_hcw: 'sap_belize_hcw'
} as const;
export type ThemeId = (typeof ThemeId)[keyof typeof ThemeId];

/**
 * @public
 * Environment flags
 */
export const Environment = {
	dev: 'dev',
	test: 'test',
	prod: 'prod'
} as const;
export type Environment = (typeof Environment)[keyof typeof Environment];
